import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { PDLButton } from "../../dna";
import Row from "react-bootstrap/Row";

const NewsletterForm = () => (
  <Form>
    {/* Desktop Layout */}
    <Row className="d-none d-md-flex">
      <Col className="ps-0">
        <Form.Control placeholder="Insira seu e-mail" />
      </Col>
      <Col className="pe-0 col-sm-auto">
        <PDLButton type="button" variant="primary">
          Assinar Newsletter
        </PDLButton>
      </Col>
    </Row>
    
    {/* Mobile Layout */}
    <div className="d-md-none">
      <Row className="mb-3">
        <Col xs={12} className="px-0">
          <Form.Control placeholder="Insira seu e-mail" />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="px-0">
          <PDLButton type="button" variant="primary" className="w-100">
            Assinar Newsletter
          </PDLButton>
        </Col>
      </Row>
    </div>
  </Form>
);

export default NewsletterForm;
